<template>
    <div :class="{ 'forex-container': !isModerator }">
        <!--        <v-page-title v-if="page === 1 && isModerator" to="admin-forex-applications" title="Назад" />-->
        <!--        <v-container-header-->
        <!--            v-if="[1, 2].includes(page) && !isModerator"-->
        <!--            class="page-back"-->
        <!--            @click="page ? page&#45;&#45; : false"-->
        <!--            >Назад-->
        <!--        </v-container-header>-->
        <v-loading v-if="loading" />
        <div class="inner-wrapper" v-else>
            <div class="page-header">
                <div>
                    <span class="page-title">Platform FX</span>
                </div>
            </div>
            <!--            <forex-introduction v-if="page === 0" @click="showNextPage" :status="statusId" :canCreate="true" />-->
            <forex-application v-if="page === 0" :data="profile" :page="page" @click="page++" />
            <forex-instructions v-else-if="page === 1" />
        </div>
    </div>
</template>

<script>
import VButton from "@/updated/common/components/VButton";
import { api } from "./services";

export default {
    name: "PlForex",
    components: {
        "forex-application": () => import("./pages/PlForexApplication"),
        "forex-instructions": () => import("./pages/PlForexInstructions"),
        VButton
    },
    props: {
        id: {}
    },
    data() {
        return {
            profile: null,
            showWarning: true,
            page: 0,
            applicationData: null,
            loading: true,
            hasLicense: null,
            statusId: null,
            canCreate: false
        };
    },
    mounted() {
        this.onload();
    },
    computed: {
        isModerator() {
            return this.$route.meta.isModerator;
        },
        title() {
            if (this.page === 1) {
                if (this.isModerator) {
                    return "Информация по запросу на выплату";
                }
                return "Торговый робот";
            } else if (this.page === 2) {
                return "Инструкция";
            }
            return "Заявка на подключение торговой системы";
        }
    },
    methods: {
        onload() {
            this.loading = true;
            let id = this.isModerator ? this.$route.params?.id : "";
            api.getUserProfile()
                .then(data => {
                    //this.canCreate = data.can_create;ф
                    console.log(data);
                    this.profile = data;
                    this.page = 0;
                    // if (this.applicationData) {
                    //     this.statusId = this.applicationData.status.id;
                    //     this.page = 1;
                    // }
                })
                .finally(() => (this.loading = false));
        },
        showNextPage(page) {
            this.page = page;
        },
        backPage() {
            if (this.isModerator) {
                this.$router.replace({ name: "admin-forex-applications" });
            } else {
                this.page ? this.page-- : false;
            }
        }
    }
};
</script>

<style lang="scss">
.forex-container {
    padding: 30px;
    @media (max-width: 768px) {
        padding: 20px 12px;
    }
}

.create-course-box__start-nav {
    margin-bottom: 0 !important;
}

.inner-wrapper {
    padding-top: 20px;
    background: #fff;
    @media (min-width: 769px) {
        margin-top: 0;
        padding: 30px;
    }
}

.page {
    &-header {
        margin: 0;
    }

    &-title {
        line-height: 1;
        margin: 0;
        display: inline-block;
        font-weight: bold;
        font-size: 18px;
    }

    &-subtitle {
        display: inline-block;
        font-size: 12px;
        color: #58606e;
    }
}

@media (min-width: 769px) {
    .inner-wrapper {
        margin-top: 0;
        padding: 30px;
    }
    .page {
        &-title {
            font-size: 24px;
            line-height: 40px;
        }

        &-subtitle {
            font-size: 14px;
        }
    }
}
</style>
